import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import type { ISourceOptions } from '@tsparticles/engine';
import { ParticlesService } from '../../services/particles.service';

@Component({
    selector: 'app-home-thirteen',
    templateUrl: './home-thirteen.component.html',
    styleUrls: ['./home-thirteen.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeThirteenComponent implements OnInit {

    constructor(
        private viewportScroller: ViewportScroller,
        private particlesService: ParticlesService
    ) {}

    public onClick(elementId: string): void {
        this.viewportScroller.scrollToAnchor(elementId);
    }

    myStyle: Record<string, string> = {};
    myParams: ISourceOptions = {};

    ngOnInit() {
        this.myStyle = { ...this.particlesService.hostStyle };
        this.myParams = this.particlesService.getDefaultOptions();
    }
}
